
import { HttpClient } from '@angular/common/http';
import {  AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { formatDate } from '@angular/common';
import { FormatDataTableGlobalFive } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2';
import { ApiServiceProject } from '../../../../../apis/ApiServiceProject';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';

@Component({
  selector: 'project-step-4',
  templateUrl: './step4-project.component.html',
  styleUrls: ['./../../create-project.component.scss']
})
export class ProjectStep4Component implements  AfterViewInit, OnDestroy, OnInit  {
@ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  listAnex = []
  extension = ''
  file:File
  listStage
  listStado
  listaEtapas
  idProject
  fileName=''
  nombrepost
  dtOptions: DataTables.Settings = {};
  step:number = 0
  title="Datos";
  crud = 'create';
  Step4form: FormGroup;
  private apiService: ApiServiceProject;
  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private errorService:ErrorService
  ) { 
   this.route.params.subscribe((params) => {
      this.idProject = params['id'];
    });
    this.route.url.subscribe((params)=>{
    this.crud=params[1].path
    })
  }
  onFileSelected(event) {
        this.file = event.target.files[0];
        if (this.file) {
          this.fileName = this.file.name;
          let index = this.fileName.split('.').length;
          this.extension = this.fileName.split('.')[index-1];
          this.nombrepost = this.fileName.slice(0,-(this.extension.length+1))
          if(index > 2){
            Swal.fire({title:"Error!" ,text: "El nombre del archivo no puede contener puntos previos a la extensión.",icon: 'error',heightAuto: false});
            this.Step4form.reset()
          }
        }
    }
  ngOnInit(): void {
    this.spinner.show()
    this.Step4form = this.fb.group({
    title:[''],
    start_date:[''],
    end_date:[''],
    archive:'',
    extend_date: false
    });
    this.dtOptions = FormatDataTableGlobalFive();
    this.apiService =  new ApiServiceProject(this.http);
     this.apiService.getService(`list-project-datos-step-four?id_project=${this.idProject}`).subscribe({
      next: (data) => {
        if (data) {
          this.listAnex = data.listInfo
          this.spinner.hide();
          this.rerender()
        } else {
          this.spinner.hide()
          Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
        }
      },
      error: (error) => {
        this.errorService.error(error);
      }
    })
    
  }

 

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  formSubmit(){
    this.spinner.show()
    let startDate = moment(this.Step4form.value.start_date).format("DD-MM-YYYY"); 
      let endDate = moment(this.Step4form.value.end_date).format("DD-MM-YYYY"); 
      
      if(this.crud == 'create'){
        let post={
      title:this.Step4form.value.title,
      start_date: startDate,
      end_date:endDate,
      name_document:this.nombrepost,
      extension:this.extension,
      projects_id:Number(this.idProject),
      extend_date : 1
    }
    this.spinner.hide()
    //Aca envio el anexo
    this.apiService.postService(`create-project-datos-step-four`,post).subscribe({
       next: (data) => {
         if (data.code == 1) {
        this.spinner.hide()
           Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
          } else {
            this.spinner.hide()
            Swal.fire({title: data.message ,text: '',icon: 'success',heightAuto: false}).then(()=>{
                
              this.spinner.show()
                const formData = new FormData();
                formData.append("file", this.file);
                this.apiService.postService(`upload-project-datos-step-four`,formData).subscribe({
                  next: (data) => {
                  if (data.code == 1) {
                    this.spinner.hide()
                    Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
                   } else {
                    this.spinner.hide();
                     Swal.fire({title: data.message ,text: '',icon: 'success',heightAuto: false}).then(()=>{
                     location.reload()
                  })
                    this.spinner.hide();
                  }
                },
               error: (error) => {
                this.errorService.error(error);
               }})
         })
           this.spinner.hide();
         }
      },
     error: (error) => {
      this.errorService.error(error);
     }})
    }else if (this.crud == 'edit'){

    if(this.Step4form.value.extend_date== null || this.Step4form.value.extend_date == undefined || this.Step4form.value.extend_date == ''){
      this.Step4form.value.extend_date = 0;
    }else if(this.Step4form.value.extend_date == true){
      this.Step4form.value.extend_date = 1;
    }else{
      this.Step4form.value.extend_date = 0;
    }
        let post={
      title:this.Step4form.value.title,
      start_date: startDate,
      end_date:endDate,
      name_document:this.nombrepost,
      extension:this.extension,
      projects_id:Number(this.idProject),
      extend_date : Number(this.Step4form.value.extend_date)
    }
    //Aca envio el anexo
    this.apiService.postService(`create-project-datos-step-four-extend`,post).subscribe({
       next: (data) => {
         if (data.code == 1) {
        this.spinner.hide()
           Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
          } else {
            this.spinner.hide();
            Swal.fire({title: data.message ,text: '',icon: 'success',heightAuto: false}).then(()=>{
                //Aca envio el archivo
                this.spinner.show();
                const formData = new FormData();
                formData.append("file", this.file);
                this.apiService.postService(`upload-project-datos-step-four`,formData).subscribe({
                  next: (data) => {
                  if (data.code == 1) {
                    this.spinner.hide()
                    Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
                   } else {
                    this.spinner.hide();
                     Swal.fire({title: data.message ,text: '',icon: 'success',heightAuto: false}).then(()=>{
                     location.reload()
                  })
                    this.spinner.hide();
                  }
                },
               error: (error) => {
                this.errorService.error(error);
               }})
         })
           this.spinner.hide();
         }
      },
     error: (error) => {
      this.errorService.error(error);
     }})
      }
    
  }
  stageDelete(id:any){
      Swal.fire({
                title: 'Eliminar',
                text: '¿Desea eliminar registro?',
                icon: 'warning',
                showCancelButton:true,
                confirmButtonText: 'Aceptar',
                cancelButtonText:"No, cancelar",
                heightAuto: false
              }).then((res) => {
                if (res.isConfirmed) {
                  this.spinner.show()
                  this.apiService.deleteService('delete-project-datos-step-four?id=' + id).subscribe({
                    next: (rs: any) => {
                      if (rs) {
                        this.spinner.hide();
                        Swal.fire({title:'Exito!',text: 'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                        
                      } else {
                          this.spinner.hide();
                          Swal.fire({
                          title:  rs.error,
                          text: '',
                          icon: 'error',
                          heightAuto: false
                          }); } },
                    error: (error) => {
                      this.errorService.error(error);
                    },});
                }
                else if ( res.dismiss === Swal.DismissReason.cancel){
                  Swal.fire({
                    title: 'Cancelado',
                    text: 'Operación cancelada.',
                    icon: 'error',
                    heightAuto: false
                    })

                }
              });
    
    
  }
  download(id:any,name:any){
      Swal.fire({
                title: 'Descargar',
                text: '¿Desea descargar el archivo?',
                icon: 'warning',
                showCancelButton:true,
                confirmButtonText: 'Descargar',
                cancelButtonText:"No, cancelar",
                heightAuto: false
              }).then((res) => {
                if (res.isConfirmed) {
                  this.spinner.show()
                 this.apiService.DownloadService('donwload-project-datos-step-four?id='+id).subscribe({
                    next: (rs: any) => {
                      if(rs.code == null){
                          let dataType = rs.type;
                          let ext = dataType.split('/')
                          let binaryData = [];
                          binaryData.push(rs);
                          let downloadLink = document.createElement('a');
                          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
                          if(ext[1] != null){
                            downloadLink.setAttribute('download', name+'.'+ext[1]);
                          }else{
                            downloadLink.setAttribute('download', name);
                          }
                          document.body.appendChild(downloadLink);
                          downloadLink.click();
                          this.spinner.hide();
                      }else{
              
                        this.spinner.hide()
                        Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
                      }
                    },
                    error: (error) => {
                      const errorJson = JSON.parse(this.blobToString(error.error));
                      if(errorJson.code == 1){
                        this.spinner.hide()
                        Swal.fire({title:errorJson.error,text: '',icon: 'error',heightAuto: false});
                      }else{
                        this.errorService.error(error);
                      }

                    },})
                }
                else if ( res.dismiss === Swal.DismissReason.cancel){
                  Swal.fire({
                    title: 'Cancelado',
                    text: 'Operación cancelada.',
                    icon: 'error',
                    heightAuto: false
                    })

                }
              });
    
    
  }

  private blobToString(blob): string {
    const url = URL.createObjectURL(blob);
    let xmlRequest = new XMLHttpRequest();
    xmlRequest.open('GET', url, false);
    xmlRequest.send();
    URL.revokeObjectURL(url);
    return xmlRequest.responseText;
}

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

}


